import { render, staticRenderFns } from "./TutorialFavorites.vue?vue&type=template&id=17e14cca&"
import script from "./TutorialFavorites.vue?vue&type=script&lang=js&"
export * from "./TutorialFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports